import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // F02: min 44px mobile (Touch), 36px ab 761px. Mobile 16px verhindert
          // iOS-Zoom beim Fokus, Desktop 14px (--fm-base).
          "flex min-h-11 min-[761px]:min-h-9 w-full rounded-md border border-input bg-background px-3 py-1.5 text-[16px] min-[761px]:text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
